import { styled } from "styled-components";

export const Value = styled.h1`
  color: var(--text-color);
  font-size: 3rem;
  font-weight: 700;
  margin: 0;
  @media screen and (max-width: 900px) {
    font-size: 2rem;
  }
`;

export const Label = styled.h3`
  color: var(--text-secondary-color);
  margin: 0;
  @media screen and (max-width: 900px) {
    font-size: 1rem;
    font-weight: 400;
  }
`;
